"use client";

import { useId } from "react";

import { useFilterSheetContext } from "@/components/sheets/FilterSheet/context";
import {
	filterSheetHeadingClassName,
	filterSheetRowLabelClassName,
} from "@/components/sheets/FilterSheet/filter-sheet-glass";
import {
	PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_DEFAULT,
	PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_MAX,
} from "@/lib/public-category-routes";
import { cn } from "@/lib/utils";

function LimitRadio({
	name,
	value,
	label,
	defaultChecked,
}: {
	name: string;
	value: string;
	label: string;
	defaultChecked: boolean;
}) {
	const inputId = useId();
	return (
		<label
			htmlFor={inputId}
			className={cn(
				"flex cursor-pointer items-center gap-3",
				filterSheetRowLabelClassName,
			)}
		>
			<input id={inputId} type="radio" name={name} value={value} defaultChecked={defaultChecked} className="peer sr-only" />
			<span
				aria-hidden
				className="relative flex size-5 shrink-0 items-center justify-center rounded-full border-solid border-[0.5px] border-white bg-transparent after:absolute after:size-2.5 after:rounded-full after:bg-[color:var(--color-brand-primary)] after:opacity-0 after:transition-opacity peer-checked:after:opacity-100 peer-focus-visible:ring-2 peer-focus-visible:ring-white/50 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-transparent"
			/>
			<span>{label}</span>
		</label>
	);
}

export default function FilterPageSizeSection() {
	const { mutSearchParams } = useFilterSheetContext();
	const groupId = useId();
	const selected =
		mutSearchParams.get("limit") === `${PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_MAX}`
			? PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_MAX
			: PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_DEFAULT;

	return (
		<div className="flex flex-col gap-3">
			<h3 className={filterSheetHeadingClassName} id={groupId}>
				Results per page
			</h3>
			<div className="flex flex-col gap-2.5" role="group" aria-labelledby={groupId}>
				<LimitRadio
					name="limit"
					value={`${PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_DEFAULT}`}
					label={`${PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_DEFAULT} services`}
					defaultChecked={selected === PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_DEFAULT}
				/>
				<LimitRadio
					name="limit"
					value={`${PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_MAX}`}
					label={`${PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_MAX} services`}
					defaultChecked={selected === PUBLIC_CATEGORY_LISTING_PAGE_LIMIT_MAX}
				/>
			</div>
		</div>
	);
}
